import { mapActions } from 'vuex';

export default {
  name: 'OverviewContainer',
  created() {
    // If this component is found in the template than use the new full-width layout
    this.setNewOverviewTab(true);
  },
  methods: {
    ...mapActions([
      'setNewOverviewTab',
    ]),
  },
};
